import NalogCheckMyemsContainer from "../containers/NalogCheckMyemsContainer";

const NalogCheckMyemnsPage = () => {

    return <NalogCheckMyemsContainer />;
};

export default NalogCheckMyemnsPage;
